import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { UserContext } from "../context/userContext";
import LocationDataClient from "../../clients/LocationDataClient";

/**
 * Custom hook for fetching dealer location data
 * @returns {Object} Query result containing data, isLoading, error, and other react-query properties
 */
export function useDealerLocationData() {
  const { user } = useContext(UserContext);
  const { market, dealerId, salesCode, brand } = user || {};
  const dealerCommonId = user
    ? `${market}|${dealerId}|${salesCode}|${brand}`
    : null;

  return useQuery({
    queryKey: ["dealerLocationData", dealerCommonId],
    queryFn: () => LocationDataClient.getDealerLocationData(dealerCommonId),
    enabled: !!dealerCommonId, // Only run query if dealerCommonId exists
    staleTime: 5 * 60 * 1000, // Mark data as stale after 5 minutes
    cacheTime: 10 * 60 * 1000, // Keep unused data in cache for 10 minutes
    refetchOnMount: false, // Don't refetch when component mounts if data is fresh
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    retries: 2, // Retry failed requests twice
  });
}

export default useDealerLocationData;
